import React from "react";
import { toast as alert } from "react-toastify";

import "./add-industry-row.css";
import WComponent from "../../../common/WComponent";
import BookkeepingService from "../../../../services/BookkeepingService";

/**
 * A text field and button that adds a new industry to the firm-wide live list.
 *
 * Industries live in a table a preparer can add to, not a list baked into the bundle, so the one
 * place that already shows a client's industry as a dropdown needs some way to grow that dropdown
 * without a deploy. This is that one place, built once and reused everywhere an industry is picked,
 * so the add-an-industry behaviour (and its loading state) cannot drift between where it is offered.
 *
 * Owns its own draft text and in-flight state; the caller only reacts to the result. `onAdded`
 * receives `{ industry, alreadyExisted }` so a caller can decide for itself whether to refetch the
 * live list, append to a local copy, or say something different about an industry that turned out
 * to already be on file — reactions differ by caller, the add itself must not.
 */
class AddIndustryRow extends WComponent {
	state = { nameToAdd: "", adding: false };

	onNameChange = event => this.update({ nameToAdd: event.target.value });

	onAdd = async () => {
		const { onAdded } = this.props;
		const name = this.state.nameToAdd.trim();
		if (!name) return;

		await this.update({ adding: true });
		const result = await BookkeepingService.addIndustry({ name });
		await this.update({ adding: false });

		if (result.error) {
			alert.error(result.error);
			return;
		}

		this.update({ nameToAdd: "" });
		if (onAdded) onAdded({ industry: result.industry, alreadyExisted: !!result.alreadyExisted });
	};

	render() {
		const { nameToAdd, adding } = this.state;

		return (
			<div className="add-industry-row">
				<input
					type="text"
					className="tk-input"
					value={nameToAdd}
					onChange={this.onNameChange}
					placeholder="Add an industry not on the list…"
					disabled={adding}
				/>
				<button type="button" className="tk-text-action" onClick={this.onAdd} disabled={adding || !nameToAdd.trim()}>
					{adding ? "Adding…" : "Add"}
				</button>
			</div>
		);
	}
}

export default AddIndustryRow;
